import React from 'react';
import { FlameIcon } from 'lucide-react';
interface UrgencyBarProps {
  formattedTime: string;
  isExpired: boolean;
}
export function UrgencyBar({
  formattedTime,
  isExpired
}: UrgencyBarProps) {
  return <div className="sticky top-0 z-50 w-full bg-urgency py-2.5 px-4" data-id="element-223">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-224">
        <div className="flex items-center gap-2 text-sm md:text-base text-body" data-id="element-225">
          <FlameIcon className="w-4 h-4 text-gold" data-id="element-226" />
          {isExpired ? <span data-id="element-227">La oferta ha expirado. Precio actual: $47.00</span> : <span className="text-center md:text-left" data-id="element-228">
              OFERTA DE TIEMPO LIMITADO — Tu descuento especial expira en:{' '}
              <span className="text-urgency-text text-xl font-bold ml-1" data-id="element-229">
                {formattedTime}
              </span>
            </span>}
        </div>
        {!isExpired && <div className="text-xs text-body/80 text-center md:text-left hidden md:block" data-id="element-230">
            Una vez que el contador llegue a cero, el precio de $6.36 ya no
            estará disponible.
          </div>}
      </div>
    </div>;
}